<template>
    <div class="posts_list">
        <single-post
            v-for="post in posts"
            :key="post.id"
            :post="post"
            :button-text="buttonText"
            :description-label="descriptionLabel"
            @apply="apply"
        />

        <div v-if="isMoreAvailable" class="more_wrapper text_center">
            <button
                class="btn btn_template"
                type="button"
                @click="$emit('get-more')"
            >
                טען עוד
            </button>
        </div>

        <modal-apply-form
            :form-id="formId"
            :questions="questions"
            :post="selectedPost"
            :description-label="descriptionLabel"
            :hide-title="hideTitle"
        />
    </div>
</template>

<script>
import ModalApplyForm from '@/components/modals/Apply';
import SinglePost from '@/components/boards/SinglePost';

export default {
    components: {
        ModalApplyForm,
        SinglePost
    },

    props: {
        formId: {
            type: String,
            required: true
        },

        posts: {
            type: Array,
            required: true
        },

        buttonText: {
            type: String,
            required: true
        },

        total: {
            type: Number,
            required: true
        },

        questions: {
            type: Array,
            default: () => []
        },

        loggedInOnly: {
            type: Boolean,
            required: false,
            default: false
        },

        labels: {
            type: Object,
            required: true
        },

        hideTitle: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            selectedPost: {},
            defaultLabels: {
                description: 'דרישות התפקיד'
            }
        };
    },

    computed: {
        isMoreAvailable() {
            return this.posts.length < this.total;
        },

        descriptionLabel() {
            return this.labels.description || this.defaultLabels.description;
        }
    },

    methods: {
        apply(post) {
            if (!this.$auth.loggedIn && this.loggedInOnly) {
                this.$router.replace({ query: { modal: 'login' } });

                return;
            }

            this.selectedPost = post;
            this.$openModal('applyForm');
        }
    }
};
</script>
